import { REPORT2025_DETAIL_UPDATE, REPORT2025_FORM_UPDATE, REPORT2025_SOURCES_UPDATE } from '../mutationTypes';

const state = {
  sources: {},
  detail: {
    id: '',
    nickName: '',
    userRegisterTime: '2025-11-01', //注册时间
    userRegisterToNowDays: 2, //练习时长
    firstBindTime: '2025-11-01', //首次绑定车辆的时间
    firstBindVehicleTypeName: '首次绑定车型名称', //首次绑定车型名称
    firstRideAddress: '杭州', //第一次骑行的地点
    firstRideTime: '2025-11-01', //第一次骑行的时间
    lastRideAddress: '杭州', //最后一次骑行的地点
    lastRideTime: '2025-11-01', //最后一次骑行的时间
    totalRideDistance: 12000, //总骑行里程(公里)
    totalRideNum: 2, //横穿中国次数
    totalRideDistanceRankRate: 50, //百分之多少的用户
    totalRideDuration: 2, //总骑行时长
    totalGameNum: 2, //从青铜打上王者次数
    throughCityCount: 5, //途经城市的数量
    totalRideCount: 2, //轨迹数
    singleMaxDistanceMileage: 222, //单次最长骑行里程(公里)
    singleMaxDistanceStartCityName: '北京', //单次最长骑行里程开始地点
    singleMaxDistanceEndCityName: '杭州', //单次最长骑行里程结束地点
    dayMaxDistanceDuration: 60, //单日最长骑行时长(分钟)
    dayMaxRideCount: 15, //单日骑行次数最多
    dayMaxRideTime: '2025-11-01', //单日骑行次数最多时间
    dayMaxDistanceMileage: 15, //单日最长骑行里程(公里)
    mostActiveMonth: '12', //最活跃月份
    mostActiveMonthCount: 22, //最活跃月份骑行次数
    totalBendingCount: 55, //压弯总次数
    totalAccelerationCount: 55, //急加速总次数
    superSpeed: 100, //最快速度
    firstPostTime: '2025-11-01', //第1次发贴时间
    totalParticipateTopicCount: 12, //参与话题总数
    integralTotal: 1000, //积分总额
    warGodAddress: '战神地址', //战神地址
    warGodTitle: '东方战神', //战神称号
    mustVisit: ['杭州', '苏州'], //此生必驾(集合)
    throughCityNameList: ['杭州', '苏州'], //途径的城市名称
    consumptionAmount: 5000, //消费金额(元)
    consumptionRanking: 20, //消费排名
    activeLevel: 20, //社区活跃度
    onePeriod: 20, //骑行时段0时-3时
    twoPeriod: 20, //骑行时段4时-6时
    threePeriod: 20, //骑行时段7时-9时
    fourPeriod: 20, //骑行时段10时-12时
    fivePeriod: 20, //骑行时段13时-15时
    sixPeriod: 20, //骑行时段16时-18时
    sevenPeriod: 20, //骑行时段19时-21时
    eightPeriod: 20, //骑行时段22时-23时
  },
  form: {
    isAgreement: false,
    submitClick: false,
  },
};
const mutations = {
  [REPORT2025_SOURCES_UPDATE](states, sources) {
    Object.keys(sources).forEach((key) => {
      states.sources[key] = sources[key];
    });
  },
  [REPORT2025_DETAIL_UPDATE](states, detail) {
    console.log('--报告数据--', detail);
    states.detail = { ...states.detail, ...detail };
  },
  [REPORT2025_FORM_UPDATE](states, value) {
    states.form = { ...JSON.parse(JSON.stringify(states.form)), ...value };
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
};
